import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";

export default class ServiceInstructionModel extends LabServiceModel {

  modelName() {
    return 'service_instruction';
  }

  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      sample_type_id: null,
      sample_type: null,
      message: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      laboratory: Object,
      sample_type_id: (val) => (this.nullStringMutator(val)),
      sample_type: Object,
      message: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }


  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }
}
